module.exports = __webpack_public_path__ + "cb99610a0e48eda61eba57f7a5fee286.png";